module.exports = "/images/vendor/flag-icon-css/flags/1x1/sd.svg?7ab061d859c16996f2bd42f650274f8e";